export interface Categoria {
    nome : string,
    icon : string
}

export const CATEGORIAS: Categoria[] = [
    {
        nome: 'Fundamentos',
        icon : 'local_library'
    },
    {
        nome: 'Nivelamento',
        icon : 'widgets'
    },
    {
        nome: 'Formação',
        icon : 'work'
    },
    {
        nome: 'Instrutoria',
        icon : 'group'
    },
]


// WEBPACK FOOTER //
// ./src/app/cursos/categoria.model.ts